module.exports = flarum.core.compat['utils/saveSettings'];